import React from 'react'
import { Table } from 'react-bootstrap'
import DropdownActionButtonMui from '../../../components/action_button/DropdownActionButtonMui'
import { formatMoneyUpToSixDecimals } from '../../../helpers/utils'
import {
  formatDateForDisplay,
  formatScopeLabelForDisplay
} from '../helpers/specialPriceHelpers'
import { SPECIAL_PRICE_INDEX_TABLE_COLUMNS } from '../constant/specialPriceViewConstants'
import SpecialPriceStatusBadge from './SpecialPriceStatusBadge'

const SpecialPriceIndexTable = ({
  canWrite,
  specialPrices,
  onCopy,
  onOpenProductDetails,
  onRowClick,
  onSuspend
}) => {
  const emptyColSpan = SPECIAL_PRICE_INDEX_TABLE_COLUMNS.length + (canWrite ? 1 : 0)

  return (
    <Table hover responsive>
      <thead className="table-header-gray-poc">
        <tr>
          {SPECIAL_PRICE_INDEX_TABLE_COLUMNS.map((column) => (
            <th
              key={column.key}
              className={[column.className, column.headerClassName].filter(Boolean).join(' ')}
            >
              {column.label}
            </th>
          ))}
          {canWrite && <th className="col-w-50 special-price-table__align-center">ACCIÓN</th>}
        </tr>
      </thead>
      <tbody>
        {specialPrices.length > 0 ? (
          specialPrices.map((specialPrice) => {
            const formattedScopeLabel = formatScopeLabelForDisplay(specialPrice.scope_label)
            const productLabel = `${specialPrice.product_db_ref} - ${specialPrice.product_name}`

            return (
              <tr
                key={specialPrice.uid}
                className="cursor-pointer"
                onClick={() => onRowClick(specialPrice.uid)}
              >
                <td>{formatDateForDisplay(specialPrice.start_date)}</td>
                <td>{formatDateForDisplay(specialPrice.end_date)}</td>
                <td>{specialPrice.external_db_ref}</td>
                <td className="td-text-limited" title={formattedScopeLabel}>
                  {formattedScopeLabel}
                </td>
                <td className="td-text-limited" title={productLabel}>
                  {specialPrice.product_id ? (
                    <a
                      className="special-price-link"
                      href={`/productos/${specialPrice.product_id}/detalles`}
                      onClick={(event) => onOpenProductDetails(event, specialPrice.product_id)}
                    >
                      {productLabel}
                    </a>
                  ) : (
                    productLabel
                  )}
                </td>
                <td>{specialPrice.sales_unit || '-'}</td>
                <td className="special-price-table__align-right">
                  {formatMoneyUpToSixDecimals(specialPrice.minimum_special_price)}
                </td>
                <td>
                  <SpecialPriceStatusBadge compact status={specialPrice.status} />
                </td>
                {canWrite && (
                  <td
                    className="special-price-table__align-center"
                    onClick={(event) => event.stopPropagation()}
                  >
                    <DropdownActionButtonMui
                      id={`special-price-actions-${specialPrice.uid}`}
                      list={[
                        {
                          text: 'Crear copia',
                          handler: () => onCopy(specialPrice)
                        },
                        {
                          disabled: specialPrice.status === 'suspended',
                          text: 'Suspender',
                          handler: () => onSuspend(specialPrice)
                        }
                      ]}
                    />
                  </td>
                )}
              </tr>
            )
          })
        ) : (
          <tr>
            <td className="td-text-limited" colSpan={emptyColSpan}>
              No hay resultados.
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  )
}

export default SpecialPriceIndexTable
